import { render, staticRenderFns } from "./CustomerOpenTickets.vue?vue&type=template&id=153ff8b9&scoped=true&"
import script from "./CustomerOpenTickets.vue?vue&type=script&lang=js&"
export * from "./CustomerOpenTickets.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOpenTickets.vue?vue&type=style&index=0&id=153ff8b9&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ff8b9",
  null
  
)

export default component.exports